var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7B7DE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9924 28.575C28.6309 27.9662 28.9811 27.2925 28.8166 26.3449C28.3309 23.5516 25.9329 21.474 23.1675 20.5798C21.0884 21.9653 18.3362 21.9653 16.2571 20.5798C13.4917 21.474 11.0921 23.5524 10.6072 26.3449C10.3526 27.8105 11.4838 29.1426 13.0342 29.1426H26.3889C26.9945 29.1426 27.5459 28.9458 27.9924 28.575ZM23.1917 12.2642C25.1133 14.1357 25.1133 17.1708 23.1917 19.0424C20.0996 22.0546 14.7904 19.9107 14.7904 15.6532C14.7904 11.3966 20.0996 9.25251 23.1917 12.264V12.2642Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.9f58fd5dd752e8fbecf1beeacaab478a.svg";
export { ForwardRef as ReactComponent };